import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import { ArticleWithRelations } from '@/models/request';

import { BaseMessage } from './BaseMessage';

export const CreateShipmentTaskMessage = ({ article }: { article: ArticleWithRelations }) => {
  const destinationName = article.toEntity?.name;
  const isSelfHandledTransitEnabled = article.selfHandledTransit?.enabled === true;

  return (
    <BaseMessage
      article={article}
      title={
        isSelfHandledTransitEnabled ? (
          <Trans id="article.task.create-shipment.title.self-handled">Handle the package</Trans>
        ) : (
          <Trans id="article.task.create-shipment.title">Ship the package</Trans>
        )
      }
      message={
        <Stack gap="0.5rem" alignItems="flex-start">
          <p>
            {isSelfHandledTransitEnabled ? (
              <>
                <Trans id="article.task.create-shipment.text.self-handled">
                  Please prepare the package and confirm that the delivery or pickup of the item is
                  being handled.
                </Trans>
              </>
            ) : (
              <>
                {article.toClient && (
                  <Trans id="article.task.create-shipment.text.to-client">
                    Create a new shipment to send the item to the client.
                  </Trans>
                )}
                {!!destinationName && (
                  <Trans id="article.task.create-shipment.text.to-entity">
                    Create a new shipment to send the item to {destinationName}.
                  </Trans>
                )}
              </>
            )}
          </p>
        </Stack>
      }
    />
  );
};
